import React from "react";
import styles from "./styles.css";

const ScreenContainer = ({ children, style }) => {
  return (
    <div className={`${"containers"}`} style={style}>
      {children}
    </div>
  );
};

export default ScreenContainer;
